import axios from 'axios';
import dayjs from 'dayjs';
import { OrderNotifications } from 'views/order-feed/types/order-notifications.type';

// GET
// /ewosapi/v1/notifications/latest/{customerNumber}
export const getNotifications = async (customerNumber: string): Promise<any> => {
  const res = await axios.get(`/ewosapi/v1/notifications/latest/${customerNumber}`, {
    params: {
      FilterMaxCount: 10,
      FilterLaterThan: dayjs().utc(true).toISOString(),
    },
  });

  return res.data;
};

// GET
// /ewosapi/v1/order/{customerNumber}/notifications
export const getOrderNotifications = async (customerNumber: string): Promise<OrderNotifications> => {
  const res = await axios.get(`/ewosapi/v1/order-distribution/${customerNumber}/notifications`);
  return res.data;
};
